module.exports = __webpack_public_path__ + "static/media/search.6fc62680.svg";